import { CSSObject } from '@chakra-ui/react';

export const StyledDatePicker: CSSObject = {
  '&&&': {
    '.chakra-input, .react-date-picker__wrapper': {
      h: '38px',
      background: 'blackAlpha.500',
      color: 'white',
      borderRadius: 'lg',
      transition: 'all .2s ease-in-out',
      fontSize: 'xs',
      px: '2',
      'input, span': {
        fontFamily: 'roboto',
        fontWeight: 'normal',
      },
      button: {
        color: 'gamma.200',
      },
      boxShadow: 'none',

      _hover: {
        bg: 'blackAlpha.600',
      },
    },
  },
};
